import { render, staticRenderFns } from "./BenefitPolicyFields.vue?vue&type=template&id=3b2866a0&scoped=true"
import script from "./BenefitPolicyFields.vue?vue&type=script&lang=js"
export * from "./BenefitPolicyFields.vue?vue&type=script&lang=js"
import style0 from "./BenefitPolicyFields.vue?vue&type=style&index=0&id=3b2866a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2866a0",
  null
  
)

export default component.exports